var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullPage',[_c('Webview',[_c('Header',{attrs:{"title":"忘記密碼"}}),_c('ResultPage',{attrs:{"submit":_vm.back}},[_vm._v(" 系統已將密碼設定信件寄至"),_c('br'),_vm._v(" steve@gmail.com ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }